import { render, staticRenderFns } from "./request-list.vue?vue&type=template&id=36f57e13&scoped=true"
import script from "./request-list.vue?vue&type=script&lang=js"
export * from "./request-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f57e13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f57e13')) {
      api.createRecord('36f57e13', component.options)
    } else {
      api.reload('36f57e13', component.options)
    }
    module.hot.accept("./request-list.vue?vue&type=template&id=36f57e13&scoped=true", function () {
      api.rerender('36f57e13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/request_list/request-list.vue"
export default component.exports